import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Translator from "Languages/Utility/Translator";
import { Grid } from "@material-ui/core";
import { khedmatColumn } from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import cellEditFactory from "react-bootstrap-table2-editor";
import { read } from "Helpers/LocalStorage";
import {
  changeKhadamtSearch,
  disableKhadamat,
  EditPriceKhedmat,
  GetAllKhedmat,
} from "Stores/actions";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import Search from "Assets/svg/icon/search.svg";
import Input from "Components/Input/Input";
import { ReactSVG } from "react-svg";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import { useTranslation } from 'react-i18next';

function TblKhadmat() {
  const { t } = useTranslation();
  const { khedmatData, khedmatDataPagination, khedmatDataSearch, rtlLayout } = useSelector((state) => ({
      khedmatData: state.khedmat.khedmatData,
      khedmatDataPagination: state.khedmat.khedmatDataPagination,
      khedmatDataSearch: state.khedmat.khedmatDataSearch,
      rtlLayout: state.settings.rtlLayout,
    })
  );
  const [sizePerPage, setSizePerPage] = useState(khedmatDataPagination.Limit);
  const [currentPage, setCurrentPage] = useState(khedmatDataPagination.Page);
  const [total, setTotal] = useState(1);
  const [tblData, setTblData] = useState(khedmatData);
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (khedmatData) {
      const isAdmin = read("StypeU") === "1";
      const isRecordRegisteredByAdmin = khedmatData?.IsG;
      const isUserHasAccessPrice2 = read("khadamatRules").accessPrice2;
      const updateKhedmatColumn = [...khedmatColumn];
      const isAllAdmin = khedmatData.every((item) => item.IsG);
      updateKhedmatColumn[5].hidden = isAdmin || (isUserHasAccessPrice2 === false && isRecordRegisteredByAdmin) || (isAllAdmin && isUserHasAccessPrice2 === false);
      updateKhedmatColumn[2].align = rtlLayout ? "right" : "left";
      updateKhedmatColumn[2].headerAlign= rtlLayout ? "right" : "left";
      setColumns(updateKhedmatColumn);
    }
    return () => setColumns(null);
  }, [khedmatData]);

  useEffect(() => {
    if (khedmatData) {
      setTblData(khedmatData);
      setTotal(khedmatDataPagination.Total);
    }
  }, [khedmatData, khedmatDataPagination]);

  const BeforeSaveCell = async (oldValue, newValue, row, column, done) => {
    newValue = convertToEnglishNumber(newValue) < 0 
      ? (-1 * convertToEnglishNumber(newValue)) 
      : convertToEnglishNumber(newValue);
    if (column.dataField === "Disable") {
      const updateNewValue = JSON.parse(newValue);
      if (oldValue !== updateNewValue) {
        try {
          setLoading(true);
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: Number(row.Id),
            Disable: updateNewValue,
          };
          await dispatch(disableKhadamat(data));
          //todo seo
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Name: khedmatDataSearch?.Name,
            Limit: khedmatDataPagination.Limit,
            Page: khedmatDataPagination.Page,
          };
          await dispatch(GetAllKhedmat(params));
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      }
    }
    if (column.dataField === "GroupPrice" || column.dataField === "UserPrice") {
      const newPrice = isNaN(newValue) ? newValue.replaceAll(",", "") : newValue;
      const oldPrice = oldValue.replaceAll(",", "");
      if (parseFloat(newPrice) !== parseFloat(oldPrice)) {
        try {
          setLoading(true);
          const data = {
            KeyUser: read("userKey"),
            KeyGroup: read("groupKey"),
            Price: +newPrice,
            IdKhedmat: row.Id,
          };
          await dispatch(EditPriceKhedmat(data));
          //todo seo
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Name: khedmatDataSearch?.Name,
            Limit: khedmatDataPagination.Limit,
            Page: khedmatDataPagination.Page,
          };
          await dispatch(GetAllKhedmat(params));
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      } else {
        done(false);
      }
    }
  };

  const setValue = (name, value) => {
    dispatch(changeKhadamtSearch({ Name: value }));
  };

  const onSearch = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Limit: sizePerPage,
        Page: 1,
        Name: convertToEnglishNumber(khedmatDataSearch.Name),
      };
      await dispatch(GetAllKhedmat(params));
      setCurrentPage(1);
    } catch (err) {
      console.error('[catch error]', err)
    }
    setLoading(false);
  }

  const onClearSearch = async (e) => {
    e.preventDefault();
    dispatch(changeKhadamtSearch({ Name: "" }));
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Limit: sizePerPage,
        Page: 1,
      };
      await dispatch(GetAllKhedmat(params));
      setCurrentPage(1);
    } catch (err) {
      console.error('[catch error]', err)
    }
    setLoading(false);
  }

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Limit: sizePerPage,
          Page: page,
          Name: khedmatDataSearch?.Name,
        };
        await dispatch(GetAllKhedmat(params));
        setCurrentPage(page);
        setSizePerPage(sizePerPage);
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    }
  };

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <Grid container spacing={2} className="mb-1">
        <Grid item lg={3} md={4} sm={6} xs={12}>
          <Input
            setValue={setValue.bind(this)}
            name="search"
            value={khedmatDataSearch ? khedmatDataSearch.Name : ""}
            placeholder={t('nameSearch')}
            type="search"
            onSearch={onSearch}
            onClearSearch={onClearSearch}
          />
        </Grid>
      </Grid>
      {columns && (
        <RemoteTable
          data={tblData}
          columns={columns}
          loading={loading}
          page={currentPage}
          sizePerPage={sizePerPage}
          totalSize={total}
          onTableChange={onTableChange}
          cellEdit={cellEditFactory({
            mode: "click",
            blurToSave: true,
            beforeSaveCell: (oldValue, newValue, row, column, done) =>
              BeforeSaveCell(oldValue, newValue, row, column, done),
          })}
          title={<Translator id="list_Khadmat" />}
        />
      )}
    </Fragment>
  );
}

export default TblKhadmat;
